import { isGuideSupported } from "@expert/solve-tools";
import { INSTALLATION_INTENT } from "./types";

interface OpenInstallationGuideProps {
    isGuideEnabled: boolean;
    isGuideOpen: boolean;
    disableAutomaticOpen: boolean;
    isCustomerSession: boolean;
    isCustomerVerificationComplete: boolean;
    isLoadingSimplrSession: boolean;
    intent?: string;
}
export function shouldOpenInstallationGuide({
    disableAutomaticOpen,
    intent,
    isCustomerSession,
    isCustomerVerificationComplete,
    isGuideEnabled,
    isGuideOpen,
    isLoadingSimplrSession,
}: Readonly<OpenInstallationGuideProps>) {
    const isInstallationGuideSupported = isGuideSupported("Installation");
    return (
        intent === INSTALLATION_INTENT &&
        isGuideEnabled &&
        isInstallationGuideSupported &&
        !isGuideOpen &&
        isCustomerSession &&
        isCustomerVerificationComplete &&
        !disableAutomaticOpen &&
        !isLoadingSimplrSession
    );
}
